<template>
  <main class="pa-15 mb-10">
    <!--  title  -->
    <h1 class="text-h5 text-xl-h4 mb-2 mb-xl-6">
      {{ TermsOfUse.title }}
    </h1>
    <!--  subtitle  -->
    <p
      :class="[
        'mb-4 lato-font-medium lato-text-sm',
        { 'lato-text-md': $vuetify.display.xlOnly },
      ]"
    >
      {{ TermsOfUse.subTitle }}
    </p>

    <!--  bullet points  -->
    <ul class="mb-10">
      <li
        v-for="(bulletPoint, index) in TermsOfUse.bullet_points"
        :key="index"
        class="mb-4"
      >
        {{ bulletPoint }}
      </li>
    </ul>

    <!--  contact points  -->
    <div>
      <p
        :class="[
          'mb-4 lato-font-medium d-inline-block mr-2 lato-text-sm',
          { 'lato-text-md': $vuetify.display.xlOnly },
        ]"
      >
        The administrative and security contact for this AUP is:
      </p>
      <a :href="`mailto:${TermsOfUse.admin_contact}`">{{
        TermsOfUse.admin_contact
      }}</a
      >.
    </div>

    <div>
      <p
        :class="[
          'mb-4 lato-font-medium d-inline-block mr-2 lato-text-sm',
          { 'lato-text-md': $vuetify.display.xlOnly },
        ]"
      >
        The privacy statements (e.g. Privacy Notices) are located at:
      </p>
      <a
        class="underline-effect"
        target="_blank"
        :href="TermsOfUse.privacy_statements"
        >{{ getHostname() }}{{ TermsOfUse.privacy_statements }}</a
      >.
    </div>
    <div>
      <p
        :class="[
          'mb-4 lato-font-medium d-inline-block mr-2 lato-text-sm',
          { 'lato-text-md': $vuetify.display.xlOnly },
        ]"
      >
        API use and data Licence statements are located at:
      </p>
      <a class="underline-effect" target="_blank" :href="TermsOfUse.api_usage"
        >{{ getHostname() }}{{ TermsOfUse.api_usage }}</a
      >.
    </div>
  </main>
</template>

<script>
import termsofUseData from "@/data/TermsofUseData.json";
import getHostname from "@/utils/generalUtils";

export default {
  name: "TermsOfUse",
  mixins: [getHostname],
  data: () => {
    return {
      TermsOfUse: termsofUseData.termsOfUse,
    };
  },
};
</script>

<style scoped lang="scss">
li {
  line-height: 1.6;
}

li::before {
  display: inline-block;
  content: "";
  -webkit-border-radius: 0.375rem;
  border-radius: 0.375rem;
  -moz-border-radius: 0.375rem;
  height: 0.4rem;
  width: 0.4rem;
  margin-right: 0.5rem;
  background-color: black;
}
</style>
